import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from './components/Layout/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import SeriesPage from './pages/SeriesPage';
import SubjectsPage from './pages/SubjectsPage';
import ClassesPage from './pages/ClassesPage';
import BooksPage from './pages/BooksPage';
import BookTypesPage from './pages/BookTypesPage';
import FilesPage from './pages/FilesPage';
import ViewPage from './pages/ViewPage';
import CreatePage from './pages/CreatePage';
import HierarchyPage from './pages/HierarchyPage';
import AppMetadataPage from './pages/AppMetadataPage';

const App = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/series" element={<SeriesPage />} />
        <Route path="/subjects" element={<SubjectsPage />} />
        <Route path="/classes" element={<ClassesPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/book-types" element={<BookTypesPage />} />
        <Route path="/files" element={<FilesPage />} />
        <Route path="/view" element={<ViewPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/hierarchy" element={<HierarchyPage />} />
        <Route path="/app-metadata" element={<AppMetadataPage />} />
        <Route path="/settings" element={<div>Settings Page (Coming Soon)</div>} />
      </Routes>
    </AdminLayout>
  );
};

export default App;
